module.exports = __webpack_public_path__ + "src/assets/img/rid.8353eb4f.jpg";